export default "__VITE_ASSET__D0D6083v__"